import {TimeTrackingImportColumnMapping} from '../../features/time-tracking-import/types';
import {Lx} from '../../i18n/consts';

export type ImportStep = 'upload' | 'mapping' | 'dataMapping' | 'preview';

export interface MappingFieldConfig {
    key: keyof TimeTrackingImportColumnMapping;
    labelId: string;
    required?: boolean;
    descriptionId: string;
    manualValueKey?: keyof TimeTrackingImportColumnMapping;
}

export const MOBILE_BREAKPOINT = 1000;
export const SUPPORTED_EXTENSIONS = ['csv', 'xlsx'];

export const EMPTY_MAPPING: TimeTrackingImportColumnMapping = {
    employeeColumn: '',
    employeeName: '',
    dateColumn: '',
    hoursColumn: '',
    projectOrAbsenceColumn: '',
    typeColumn: '',
    noteColumn: '',
    tagsColumn: '',
};

export const DEFAULT_MAPPING: TimeTrackingImportColumnMapping = {
    employeeColumn: 'Expert',
    employeeName: '',
    dateColumn: 'Date',
    hoursColumn: 'Hours',
    projectOrAbsenceColumn: 'Project/Absence',
    typeColumn: 'Type',
    noteColumn: 'Comment',
    tagsColumn: 'Tags',
};

export const MAPPING_FIELDS: MappingFieldConfig[] = [
    {
        key: 'employeeColumn',
        labelId: Lx.TimeTrackingImport.MAPPING_EMPLOYEE_COLUMN,
        required: true,
        descriptionId: Lx.TimeTrackingImport.MAPPING_EMPLOYEE_COLUMN_DESCRIPTION,
        manualValueKey: 'employeeName',
    },
    {
        key: 'dateColumn',
        labelId: Lx.TimeTrackingImport.MAPPING_DATE_COLUMN,
        required: true,
        descriptionId: Lx.TimeTrackingImport.MAPPING_DATE_COLUMN_DESCRIPTION,
    },
    {
        key: 'hoursColumn',
        labelId: Lx.TimeTrackingImport.MAPPING_HOURS_COLUMN,
        required: true,
        descriptionId: Lx.TimeTrackingImport.MAPPING_HOURS_COLUMN_DESCRIPTION,
    },
    {
        key: 'projectOrAbsenceColumn',
        labelId: Lx.TimeTrackingImport.MAPPING_PROJECT_ABSENCE_COLUMN,
        required: true,
        descriptionId: Lx.TimeTrackingImport.MAPPING_PROJECT_ABSENCE_COLUMN_DESCRIPTION,
    },
    {
        key: 'typeColumn',
        labelId: Lx.TimeTrackingImport.MAPPING_TYPE_COLUMN,
        descriptionId: Lx.TimeTrackingImport.MAPPING_TYPE_COLUMN_DESCRIPTION,
    },
    {
        key: 'noteColumn',
        labelId: Lx.TimeTrackingImport.MAPPING_COMMENT_COLUMN,
        descriptionId: Lx.TimeTrackingImport.MAPPING_COMMENT_COLUMN_DESCRIPTION,
    },
    {
        key: 'tagsColumn',
        labelId: Lx.TimeTrackingImport.MAPPING_TAGS_COLUMN,
        descriptionId: Lx.TimeTrackingImport.MAPPING_TAGS_COLUMN_DESCRIPTION,
    },
];

export const HEADER_ALIASES: Record<keyof TimeTrackingImportColumnMapping, string[]> = {
    employeeColumn: ['expert', 'employee', 'employee name', 'user'],
    employeeName: [],
    dateColumn: ['date', 'work date'],
    hoursColumn: ['hours', 'worked hours'],
    projectOrAbsenceColumn: ['project/absence', 'project or absence', 'project', 'absence'],
    typeColumn: ['type', 'shift type', 'absence type'],
    noteColumn: ['note', 'comment', 'description'],
    tagsColumn: ['tags', 'tag', 'labels'],
};

export const STEP_ITEMS: Array<{id: ImportStep; label: string}> = [
    {id: 'upload', label: 'Upload'},
    {id: 'mapping', label: 'Mapping'},
    {id: 'dataMapping', label: 'Data Mapping'},
    {id: 'preview', label: 'Preview'},
];
